import {
  addRoute as addRouteApi,
  fetchProviders as fetchProvidersApi,
  fetchRequesters as fetchRequestersApi,
} from "../api/routeApi";
import { Route, Transport } from "../types/Route";

export const addRoute = async (routeData: Route): Promise<any> => {
  return await addRouteApi(routeData);
};

export const fetchProviders = async (): Promise<Transport[]> => {
  return await fetchProvidersApi();
};

export const fetchRequesters = async (): Promise<Transport[]> => {
  return await fetchRequestersApi();
};
